/* eslint-disable react/destructuring-assignment */
import { useAccount } from "hooks/useAccounts";
import moment from "moment";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { arrayOf, bool, func, instanceOf, number, shape, string } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { actions as fileActions } from "reducers/files";
import * as config from "util/config";
import { useSelector } from "react-redux";
import LotPaymentTable from "./LotPaymentTable";

const FORM_ID = "payments.newPayment";

const LotPaymentSummaryBody = (props) => {
    const { id } = useParams();
    const { user } = useSelector((state) => state.session);
    const { transactionLines } = useSelector((state) => state.form);
    const isLoading = transactionLines?.fetching;
    const { isDesktop, fromTransactionPage, showMoreData, setShowMoreData } = props;
    const { formatAccountBody, dispatch } = useAccount();
    const { transaction = {} } = useContext(TransactionContext);
    const [pageNumber, setPageNumber] = useState(2);
    const isBackoffice = window.self !== window.top;

    const toggleShowMore = () => {
        setShowMoreData((prev) => !prev);
    };

    const { data = {}, idTransactionStatus = props.status } = transaction;
    const {
        typePayment = props.typePayment,
        dateProcess = props.dateProcess,
        processedFileData = props.processedFileData,
        accountInfo = props.accountInfo,
        file = props.file,
    } = data;

    const fileId = (file?.length > 0 && file[0].fileId) || processedFileData?.idFile;

    const setHour = (paymentDate) => {
        const hours = config.get("transfer.schedule.endTime", "16:00").split(":");
        return paymentDate && hours.length === 2
            ? moment(paymentDate).set({ hour: hours[0], minute: hours[1], second: "00" })
            : moment(paymentDate);
    };

    useEffect(() => {
        if (isBackoffice) {
            return;
        }
        if (fileId && user?.userId && !fromTransactionPage) {
            dispatch(fileActions.getFileContentsRequest(fileId, false, user?.userId));
            dispatch(transactionLinesActions.initializeEditedLines());
            dispatch(transactionLinesActions.setPageNumber(0));
        }

        if (idTransactionStatus === "PENDING") {
            dispatch(fileActions.getFileContentsRequest(fileId, false, user?.userId));
        }
    }, []);

    const showMoreLogs = () => {
        dispatch(
            transactionLinesActions.listTransactionLinesRequest({
                id,
                pageNumber,
                status: "TODOS",
                fileId,
            }),
        );
        setPageNumber(pageNumber + 1);
    };

    if (fromTransactionPage) {
        return (
            <>
                <GridTable className="newpayment ticket__body">
                    <GridTable.Container columns={isDesktop ? 3 : 1} rows={4} className="!grid">
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText={`${FORM_ID}.typePayment.label`}
                                titleTextType="I18N"
                                valueText={`lotPayment.type.${typePayment}`}
                                valueTextType="I18N"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <CustomData
                                titleText={`${FORM_ID}.debitAccountId.label`}
                                titleTextType="I18N"
                                valueText={`${accountInfo?.accountType} ${formatAccountBody(accountInfo)}`}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={2}>
                            <CustomData
                                titleText={`${FORM_ID}.dateProcess.label`}
                                titleTextType="I18N"
                                valueText={<FormattedDate date={dateProcess} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={2}>
                            <CustomData
                                titleText={`${FORM_ID}.filesMetadata.label`}
                                titleTextType="I18N"
                                valueText={processedFileData?.filesMetadata.fileName}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={3} rowStart={2}>
                            <CustomData
                                titleText={`${FORM_ID}.linesNumber.label`}
                                titleTextType="I18N"
                                valueText={processedFileData?.validLines}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={3}>
                            <CustomData
                                titleText="forms.inputFile.massivePayments.totalAmount"
                                titleTextType="I18N"
                                valueText={processedFileData?.totalAmount?.quantity}
                                valueTextType={processedFileData?.totalAmount?.currency}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={3}>
                            {props.willCancel ? (
                                <CustomData
                                    titleText="payments.status.label"
                                    titleTextType="I18N"
                                    valueText={`payments.thirdPayment.detail.status.${idTransactionStatus}`}
                                    valueTextType="I18N"
                                />
                            ) : (
                                <CustomData
                                    titleText={`${FORM_ID}.deadlineDate.label`}
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedDate date={setHour(dateProcess)} dateFormat="DD/MM/YYYY HH:mm:ss" />
                                    }
                                />
                            )}
                        </GridTable.Data>
                        {!!processedFileData?.linesWithNoAmount && (
                            <GridTable.Data columnStart={2} rowStart={4}>
                                <I18n
                                    componentProps={{ className: "alert alert-warning mTop", role: "alert" }}
                                    LINE_COUNT={processedFileData?.linesWithNoAmount}
                                    id="massive.payments.warning.noAmount"
                                />
                            </GridTable.Data>
                        )}
                        <GridTable.Data columnStart={1} columnWidth={3}>
                            <div className="ticket__divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                        </GridTable.Data>
                        {!isBackoffice && (
                            <>
                                <GridTable.Data columnStart={1} columnWidth={3} id="element-to-ignore">
                                    {!isLoading && (
                                        <Button
                                            aria-expanded={showMoreData ? "true" : "false"}
                                            className="more-button"
                                            label={showMoreData ? "transfers.showLess" : "transfers.showMore"}
                                            bsStyle="link"
                                            onClick={toggleShowMore}
                                            image={
                                                showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"
                                            }
                                        />
                                    )}
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} columnWidth={3} flexDirection="column">
                                    {showMoreData ? (
                                        <>
                                            <LotPaymentTable
                                                fromTransactionPage
                                                isDesktop={props.isDesktop}
                                                showMoreLogs={showMoreLogs}
                                                pageNumber={pageNumber}
                                                // idTransactionStatus={idTransactionStatus}
                                            />
                                            <div className="ticket__divider divider_1 inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                        </>
                                    ) : null}
                                </GridTable.Data>
                            </>
                        )}
                    </GridTable.Container>
                    <TransactionSign
                        showMoreData={showMoreData}
                        noHorizontalDivider
                        creationTime
                        isSmall
                        isDesktop={props.isDesktop}
                        noDate
                    />
                </GridTable>
            </>
        );
    }
    return (
        <GridTable className="form-summary transaction-ticket">
            <GridTable.Container columns={3} rows={4}>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={`${FORM_ID}.typePayment.label`}
                        titleTextType="I18N"
                        valueText={`lotPayment.type.${typePayment}`}
                        valueTextType="I18N"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={1}>
                    <CustomData
                        titleText={`${FORM_ID}.debitAccountId.label`}
                        titleTextType="I18N"
                        valueText={`${accountInfo?.accountType} ${formatAccountBody(accountInfo)}`}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={2}>
                    <CustomData
                        titleText={`${FORM_ID}.dateProcess.label`}
                        titleTextType="I18N"
                        valueText={<FormattedDate date={dateProcess} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={2}>
                    <CustomData
                        titleText={`${FORM_ID}.filesMetadata.label`}
                        titleTextType="I18N"
                        valueText={processedFileData?.filesMetadata.fileName}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={3} rowStart={2}>
                    <CustomData
                        titleText={`${FORM_ID}.linesNumber.label`}
                        titleTextType="I18N"
                        valueText={processedFileData?.validLines}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={3}>
                    <CustomData
                        titleText="forms.inputFile.massivePayments.totalAmount"
                        titleTextType="I18N"
                        valueText={processedFileData?.totalAmount?.quantity}
                        valueTextType={processedFileData?.totalAmount?.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={3}>
                    {props.willCancel ? (
                        <CustomData
                            titleText="payments.status.label"
                            titleTextType="I18N"
                            valueText={`payments.thirdPayment.detail.status.${idTransactionStatus}`}
                            valueTextType="I18N"
                        />
                    ) : (
                        <CustomData
                            titleText={`${FORM_ID}.deadlineDate.label`}
                            titleTextType="I18N"
                            valueText={<FormattedDate date={setHour(dateProcess)} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    )}
                </GridTable.Data>
                {!!processedFileData?.linesWithNoAmount && (
                    <GridTable.Data columnStart={2} rowStart={4}>
                        <I18n
                            componentProps={{ className: "alert alert-warning mTop", role: "alert" }}
                            LINE_COUNT={processedFileData?.linesWithNoAmount}
                            id="massive.payments.warning.noAmount"
                        />
                    </GridTable.Data>
                )}
            </GridTable.Container>
            <div className="view-more-data-button">
                <div className="ticket__divider inside-ticket__body" />
                {!isLoading && (
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={showMoreData ? "transfers.showLess" : "transfers.showMore"}
                        bsStyle="link"
                        onClick={toggleShowMore}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                )}
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <LotPaymentTable isDesktop={props.isDesktop} fromTransactionPage={false} />
                {/* <GridTable.Container columns={3}>
                    <GridTable.Data columnStart={1} columnWidth="3" flexDirection="column">
                    </GridTable.Data>
                </GridTable.Container> */}
            </div>
        </GridTable>
    );
};

LotPaymentSummaryBody.propTypes = {
    typePayment: string,
    dateProcess: instanceOf(Date),
    file: arrayOf(
        shape({
            fileId: number,
            fileName: string,
            fileSize: number,
        }),
    ).isRequired,
    processedFileData: shape({
        fileIdentifier: string,
        fileName: string,
        totalAmount: shape({
            quantity: number,
            currency: string,
        }),
    }).isRequired,
    accountInfo: shape({}).isRequired,
    status: string,
    willCancel: bool,
    isDesktop: bool.isRequired,
    fromTransactionPage: bool,
    showMoreData: bool,
    setShowMoreData: func,
};

LotPaymentSummaryBody.defaultProps = {
    typePayment: "",
    status: "",
    willCancel: false,
    dateProcess: null,
    fromTransactionPage: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default LotPaymentSummaryBody;
